import { z } from '../../zod';
import {
  ThemeOverridesInputValidationSchema,
  ThemeOverridesToolInputValidationSchema,
} from '../themeOverrides';
import { THEME_VARIABLES_INPUT_DESCRIPTION, ThemeNameValidationSchema } from './create';
import { ThemeGetParamsValidationSchema } from './get';

// Field-level meta on variables would inline the whole ThemeOverridesInput schema instead of a $ref.
export const UpdateThemeBodyValidationSchema = z
  .object({
    name: ThemeNameValidationSchema.optional(),
    variables: ThemeOverridesInputValidationSchema.nullish(),
  })
  .refine(body => body.name !== undefined || body.variables !== undefined, {
    message: 'Send name or variables.',
  });

export const UpdateThemeToolInputValidationSchema = ThemeGetParamsValidationSchema.extend({
  name: ThemeNameValidationSchema.optional(),
  variables: ThemeOverridesToolInputValidationSchema.meta({
    description: `${THEME_VARIABLES_INPUT_DESCRIPTION} Order bump styling, which only the dashboard can change, is kept. Call \`list_theme_properties\` for the supported properties.`,
  }),
});
